import React from 'react'
import Layout from '../../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const BasicComputerizedMeltIndexer = () => {

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000
    };

    const images = [
        '/img/instruments/BasicComputerizedMelt.png',
        '/img/instruments/BasicComputerizedMelt.png'
    ];


    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/industrial">Industrial</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Basic Computerized Melt Indexer</h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Basic Computerized Melt Indexer</h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                    Precision instrument designed to measure the OPACITY in Film Transparent, clear and diffuse clear plastic,
                                    black or black / white based on Polyethylene and its copolymers, designed for use in Horticulture, Floriculture,
                                    Food, Garbage Bag … it Measures the OPACITY of films with thicknesses of 10 and 250 microns. Benefits are such
                                    as LONG DURATION OF ILLUMINATION ,LOW ENERGY CONSUMPTION (100W) , LIGHT ADJUSTMENT,
                                    FAST MEASURING STABILIZATION REPRODUCTABILITY OF THE RESULTS ,EASY HANDLING –
                                    SIMPLE METHOD
                                </p>
                            </div>
                            {/* <div className="portfolio-description"></div> */}
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default BasicComputerizedMeltIndexer
